module.exports = __webpack_public_path__ + "static/img/a_07.cd2fa73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a_07.png
// module id = LhlZ
// module chunks = 1